const customerPaymentsPathPattern =
  /^\/(en|ru)\/crm\/(?:user-profiles|customers)\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/payments$/iu;

function splitApplicationPath(
  value: string
): { pathname: string; search: string; hash: string } | undefined {
  if (!value.startsWith('/') || value.startsWith('//')) return undefined;

  const hashIndex = value.indexOf('#');
  const withoutHash = hashIndex === -1 ? value : value.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : value.slice(hashIndex);
  const queryIndex = withoutHash.indexOf('?');
  return queryIndex === -1
    ? { pathname: withoutHash, search: '', hash }
    : { pathname: withoutHash.slice(0, queryIndex), search: withoutHash.slice(queryIndex), hash };
}

/**
 * Allows a shared Payment detail to return only to the exact User Profile
 * Payments route that opened it, preserving directory-owned search state.
 */
export function normalizeCrmCustomerPaymentsReturnTo(
  value: string | undefined,
  expectedCustomerId?: string
): string | undefined {
  if (value === undefined) return undefined;
  const parsed = splitApplicationPath(value);
  if (parsed === undefined) return undefined;
  const match = customerPaymentsPathPattern.exec(parsed.pathname);
  if (
    match === null ||
    (expectedCustomerId !== undefined &&
      match[2].toLowerCase() !== expectedCustomerId.toLowerCase())
  ) {
    return undefined;
  }
  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
